import { PropTypes } from 'typed/imports';
import { PureComponent } from 'typed/components/utils';
import { default as FormattedNumber } from '../FormattedNumber/FormattedNumber';
import './ProgressBar.less';

export enum Appearance { BAR = 'BAR', RING = 'RING' }

interface CommonProps {
    value?: number;
    format?: string;
    min?: number;
    max?: number;
    className?: string;
}

interface BarProps extends CommonProps {
    appearance: Appearance.BAR;
}

interface RingProps extends CommonProps {
    appearance: Appearance.RING;
    diameter?: number;
}

export default class ProgressBar extends PureComponent<CommonProps | BarProps | RingProps> {
    static readonly Appearance = Appearance;

    static readonly propTypes = {
        appearance: PropTypes.oneOf(Object.values(Appearance)),
        diameter: PropTypes.number,
        value: PropTypes.number,
        format: PropTypes.string,
        min: PropTypes.number,
        max: PropTypes.number,
        className: PropTypes.string
    };

    static readonly defaultProps = {
        appearance: Appearance.BAR,
        diameter: 35,
        value: 0,
        format: '0. %',
        min: 0,
        max: 100,
        className: ''
    };

    render() {
        const
            props = this.props as Required<BarProps | RingProps>,
            { value, format, min, max, className } = props;
        return props.appearance === Appearance.BAR ?
            <div className={`progress-bar ${className}`}>
                <div className="filler" style={{ width: `${Math.clamp(0, 100 * (value - min) / (max - min), 100)}%` }} />
                {format ? <div className="text"><FormattedNumber format={format} value={value / 100} /></div> : null}
            </div> :
            <div className={`progress-bar ring ${className}`} style={{ height: `${props.diameter}px`, width: `${props.diameter}px` }}>
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50%" cy="50%" r="50%" />
                    <circle className="filler"
                        cx="50%" cy="50%" r="50%"
                        strokeDasharray={`${Math.clamp(0, 100 * (value - min) / (max - min), 100) * Math.PI}% ${100 * Math.PI}%`} />
                </svg>
                {format ? <div className="text"><FormattedNumber format={format} value={value / 100} /></div> : null}
            </div>;
    }
}
